import { isExpired, DAY } from 'lib/expirationHelpers';
import CohortGateway from 'adapters/gateways/CohortGateway';

export default class LocalStorageGateway {
  constructor(appId) {
    this.appId = appId;
    this.hasMutated = false;
    this.deprecatedCohortStorage = new CohortGateway();
  }

  save(key, value) {
    this.hasMutated = true;

    let rawValue = localStorage.getItem(this.appId);
    let storedValue;
    if (rawValue) {
      storedValue = JSON.parse(rawValue);
    } else {
      storedValue = {
        values: {},
      };
    }

    storedValue.updatedAt = Date.now();
    storedValue.values[key] = value;
    localStorage.setItem(this.appId, JSON.stringify(storedValue));
  }

  delete(key) {
    this.hasMutated = true;

    let data = readLocalStorage(this.appId);
    if (!data) {
      return;
    }
    delete data.values[key];
    localStorage.setItem(this.appId, JSON.stringify(data));
  }

  getInitialState(key) {
    if (this.hasMutated) {
      throw "can't read state after it has been mutated.";
    }

    const data = readLocalStorage(this.appId);
    if (!data) {
      return null;
    }

    if (isExpired(data.updatedAt, DAY)) {
      localStorage.removeItem(this.appId);
      return null;
    }

    return data.values[key];
  }
}

function readLocalStorage(appId) {
  const rawData = localStorage.getItem(appId);
  if (!rawData) {
    return null;
  }

  return JSON.parse(rawData);
}
